// Public product help page at /help/:page (e.g. /help/connect-msp,
// linked from the signup wizard's connect step). Sacristy-branded and
// parish-agnostic — the parish-scoped help center at /:parish/help is
// a different surface with its own view.

import { useParams } from "react-router-dom";
import { loadProductHelp } from "../lib/productHelp";
import SacristyLogo from "../components/SacristyLogo";
import PoweredByFooter from "../components/PoweredByFooter";
import NotFound from "./NotFound";

export default function ProductHelp() {
  const { page } = useParams();
  const help = page ? loadProductHelp(page) : null;
  if (!help) return <NotFound />;

  return (
    <main className="page page--product-help">
      <div className="product-help__brand">
        <SacristyLogo />
      </div>
      <h1 className="product-help__title">{help.title}</h1>
      <article
        className="product-help__body"
        // Repo-authored markdown compiled at build time — same trust
        // model as the parish help center.
        dangerouslySetInnerHTML={{ __html: help.html }}
      />
      <PoweredByFooter />
    </main>
  );
}
